<script lang="ts">
	import { onMount } from 'svelte';
	import graphQLClient from '../graphql/client';
	import { setClient } from 'svelte-apollo';
	import { graphQLErrors as graphQLErrorsStore } from '../stores';

	onMount(() => {
		graphQLClient.addOnErrorListener((errors: string[]) => graphQLErrorsStore.set(errors));
	});

	setClient(graphQLClient.client);
</script>

<slot />
